// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b3b29214","952":"64afd151"}[chunkId] + ".chunk.js";
};